<template>
  <div class="property-photo-modal">
    <bg-modal :value="isShowPhoto" :title="filteredTitle" @close="handleClose">
      <div class="property-photo-modal__swiper">
        <div
          class="property-photo-modal__swiper-nav property-photo-modal__swiper-nav--prev"
        >
          <bg-button-icon
            v-if="slideData.length > 1"
            icon="chevron-left"
            size="lg"
            class="property-photo-modal__swiper-nav-icon"
          />
        </div>
        <bg-swiper-next
          :slides="slideData"
          :show-navigation="true"
          :loop="false"
          navigation-next-el=".property-photo-modal__swiper-nav--next"
          navigation-prev-el=".property-photo-modal__swiper-nav--prev"
          swiper-id="property-photo-modal"
          class="property-photo-modal__swiper-image"
          image-ratio="1:1"
        />
        <div
          class="property-photo-modal__swiper-nav property-photo-modal__swiper-nav--next"
        >
          <bg-button-icon
            v-if="slideData.length > 1"
            icon="chevron-right"
            size="lg"
            class="property-photo-modal__swiper-nav-icon"
          />
        </div>
      </div>
    </bg-modal>
  </div>
</template>

<script>
import { BgModal, BgSwiperNext, BgButtonIcon } from 'bangul-vue';

export default {
  name: 'PropertyPhotoModal',

  components: {
    BgModal,
    BgSwiperNext,
    BgButtonIcon,
  },

  computed: {
    slideData() {
      const slideImages = this.slides.map((item, i) => ({
        id: `$(this.title}-${i}`,
        imageUrl: item,
        imageAlt: this.filteredTitle,
      }));

      return slideImages;
    },

    filteredTitle() {
      return this.$options.filters.photoTitle(this.title);
    },
  },

  filters: {
    photoTitle(value) {
      switch (value) {
        case 'buildings':
          return 'Foto Bangunan';
        case 'roadview':
          return 'Foto Tampak dari Jalan';
        case 'rooms':
          return 'Foto Kamar';
        case 'bathrooms':
          return 'Foto Kamar Mandi';
        case 'shared_facilities':
          return 'Foto Fasilitas Umum';
        case 'rules':
          return 'Foto Peraturan Kos';
        case 'others':
          return 'Foto Lainnya';
        default:
          return '';
      }
    },
  },

  props: {
    isShowPhoto: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    slides: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    handleClose() {
      this.$emit('handle-close-modal');
    },
  },
};
</script>

<style lang="scss" scoped src="./PropertyPhotoModal.scss"></style>
